/**
 * Identity and Access Management - User and Client Identities
 * Identity Management
 *
 * OpenAPI spec version: 1-0
 * Contact: suporte-api-digital@br.experian.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpParams}                           from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../../util/codecs/encoder';
import { Observable }                                        from 'rxjs';
import {environment} from "../../../../../environments/environment";
import {ApiService} from "../../util/api.service";
import { HeadersRequest } from '../../util/model/header-request.inteface';
import { catchError } from 'rxjs/operators';

@Injectable()
export class IamService {

    private basePath = environment.basePathIam;

    constructor(protected apiService: ApiService, @Optional() @Inject('basePath') basePath: string) {
      if (basePath) {
        this.basePath = basePath;
      }
    }



    public identifyClient(): Observable<any> {

        let clientId = environment.clientId;

        if (clientId === null || clientId === undefined) {
            throw new Error('Required parameter clientId was null or undefined when calling identifyClient.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientId !== undefined && clientId !== null) {
            queryParameters = queryParameters.set('clientId', <any>clientId);
        }


        const headers: Array<HeadersRequest> = new Array<HeadersRequest>();
        headers.push({param: 'Content-Type', value: 'application/json'});

        const uri: string = environment.iam.client.identity;
        return this.apiService.post<any>(this.basePath + uri, null ,headers , queryParameters);

    }

    public leverageAuthStrong(authorization: string): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling leverageAuthStrong.');
        }

        const headers: Array<HeadersRequest> = new Array<HeadersRequest>();
        headers.push({param: 'Authorization', value: 'Bearer ' + authorization});
        headers.push({param: 'Content-Type', value: 'application/json'});

        const uri: string = environment.iam.user.leverageIdentifyStrong;
        return this.apiService.post<any>(this.basePath + uri, null, headers);

    }



    public authStrong(authorization: string, token?: string, credential?:string ): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling authStrong.');
        }

        let valor = {
            "token": token,
            "credential": credential
        }

        const headers: Array<HeadersRequest> = new Array<HeadersRequest>();
        headers.push({param: 'Authorization', value: 'Bearer ' + authorization});
        headers.push({param: 'Content-Type', value: 'application/json'});

        const uri: string = environment.iam.user.authIdentityStrong;
        return this.apiService.post<any>(this.basePath + uri, valor, headers);

    }




    public changeAccount(authorization: string): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling changeAccount.');
        }


        const headers: Array<HeadersRequest> = new Array<HeadersRequest>();
        headers.push({param: 'Authorization', value: 'Bearer ' + authorization});
        headers.push({param: 'Content-Type', value: 'application/json'});
        const uri: string = environment.iam.user.changeAccount;
        return this.apiService.post<any>(this.basePath + uri, null, headers,null).pipe(
          catchError(error => {
            setTimeout(() => {
              window.location.href = "/error";
            }, 3000);
            throw error;
          })
        );


     }


}
